var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactS1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 294,
    viewBox: "0 0 454 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_402)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 582,
    height: 294
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.19928 0H581.199V294H0.19928V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.19928 148.577V214.526C48.7922 260.685 186.794 293.955 349.4 293.955C408.677 294.182 467.867 289.384 526.33 279.612L581.199 267.993V202.09C517.917 218.316 437.262 228.029 349.4 228.029C186.794 228.029 48.7922 194.737 0.19928 148.6",
    fill: "#B7AAA3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.337 106.48C189.978 110.429 88.153 136.595 64.5274 170.386C61.246 166.034 59.4167 160.763 59.2975 155.317C59.2975 114.854 169.717 81.4712 312.426 76.5013L307.878 42.2334C158.12 47.9069 37.6273 83.6726 9.52213 129.9C5.55847 123.703 3.39389 116.531 3.26895 109.181C3.26895 48.9509 158.302 1.52588e-05 349.331 1.52588e-05V105.867L316.337 106.48Z",
    fill: "#B7AAA3",
    fillOpacity: 0.4
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 581,
    height: 294,
    fill: "white",
    transform: "matrix(-1 0 0 1 581.199 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactS1);
export default __webpack_public_path__ + "static/media/Contact-S1.097c810ed52c724a09d60aea881768c7.svg";
export { ForwardRef as ReactComponent };